import React from "react"

import * as tabbedDataStyles from "../styles/TabbedData.module.css"

import { ChildSelector } from "../helpers/ChildSelector"

function TabbedData(props) {
  const [openTab, setOpenTab] = React.useState(0)

  const { content } = props

  const tabsNodes = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes(`tabbed-data-column`),
  )

  const heading = ChildSelector.select(
    content,
    `tabbed-data-heading`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const tabs = tabsNodes.map(node => {
    const children = node.childNodes
    if (!children || !children.length) return { title: ``, desc: ``, cols: [] }

    const titleNode = children.filter(node => node.rawTagName === `h3`)[0]
    const title = (titleNode && titleNode.text) || ``

    const descNode = children.filter(node => node.rawTagName === `p`)[0]
    const desc = (descNode && descNode.text) || ``

    const subColumnsNode = children.filter(node =>
      node.classNames.trim().split(/\s+/).includes("tabbed-data-subcolumn"),
    )

    let cols = []
    if (subColumnsNode && subColumnsNode.length) {
      cols = subColumnsNode.map(elem => {
        return elem.childNodes.reduce((acc, node) => {
          if (node.rawTagName === `h4`) acc.title = node.innerHTML || ``
          if (node.rawTagName === `p`) acc.desc = node.text || ``

          return acc
        }, {})
      })
    }

    return { title, desc, cols }
  })

  return (
    <div className={`row ${props.className} ${tabbedDataStyles.wrapper}`}>
      <div className="col-12">
        <div className="row">
          <div className={`col-12 ${tabbedDataStyles.title}`}>
            <h2>{heading}</h2>
          </div>
        </div>

        <div className="row">
          <div className={`col-12 col-lg-4 ${tabbedDataStyles.tabList}`}>
            <ul>
              {tabs &&
                tabs.map((tab, idx) => (
                  <li key={idx}>
                    <a
                      href="#!"
                      className={`${tabbedDataStyles.dataTab} ${
                        idx === openTab
                          ? tabbedDataStyles.activeTab
                          : tabbedDataStyles.inactiveTab
                      }`}
                      onClick={evt => {
                        evt.preventDefault()
                        setOpenTab(idx)
                      }}
                    >
                      <h3>{tab.title}</h3>
                      {idx === openTab && <p>{tab.desc}</p>}
                    </a>
                    <div
                      className="d-lg-none"
                      style={{ display: idx === openTab ? `block` : `none` }}
                    >
                      <ul>
                        {tab.cols &&
                          tab.cols.map((col, indx) => (
                            <li key={indx}>
                              <span>
                                <h5
                                  dangerouslySetInnerHTML={{
                                    __html: col.title,
                                  }}
                                ></h5>
                                <p>{col.desc}</p>
                              </span>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
          <div
            className={`d-none d-lg-flex col-lg-8 ${tabbedDataStyles.subTabcontent}`}
          >
            <ul>
              {tabs &&
                tabs[openTab] &&
                tabs[openTab].cols &&
                tabs[openTab].cols.map((col, indx) => (
                  <li key={indx}>
                    <span>
                      <h5
                        dangerouslySetInnerHTML={{
                          __html: col.title,
                        }}
                      ></h5>
                      <p>{col.desc}</p>
                    </span>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TabbedData
